import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { SynchronizeService } from '../shared/services/synchronize.service';
import { BaseService } from '../shared/services/baseService';
import { ApplicationService, PeopleService, LanguageService } from '../shared/services';
import { flatMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SynchronizationResolver extends BaseService {
  constructor(
    private synchronization: SynchronizeService,
    private applicationService: ApplicationService,
    private people: PeopleService,
    private language: LanguageService
  ) {
    super();
  }

  resolve(): Observable<any> {
    if (!this.isConnection || this.synchronization.isLoaded) {
      return of(true);
    } else {
      return this.people.getCurrent().pipe(
        flatMap((person) => {
          return this.applicationService.getCurrent().pipe(
            flatMap((app) => {
              return this.language.loadTranslations(person.language ? person.language : 'en').pipe(
                flatMap((translation) => {
                  return this.synchronization.synchronizeAppReferentials();
                })
              );
            })
          );
        })
      );
    }
  }
}
